import { request } from 'apis/lib/request_cms';
import { baseUrlFile } from 'utils/ces/ce_upload';
import { request as request_video } from 'apis/lib/request_video';
const comUrl = 'mwebapi/';

// 查询可用图片列表
export function getList(params) {
    return request({
        url: comUrl + 'cms/pictureLib/findByPagination',
        method: 'get',
        params,
    });
}
// 查询可用标签列表
export function findLabelsByTid(params) {
    return request({
        url: comUrl + 'cms/content/findLabelsByTid',
        method: 'post',
        params,
    });
}
// 上传图片
export function upload(data) {
    return request({
        url: comUrl + 'cms/repository/addImage',
        method: 'post',
        data,
        timeout: 15 * 1000,
    });
}
// 登录oss
export function getResourceSign(params) {
    return request({
        url: `${comUrl}cms/resourceToken/getSign`,
        method: 'get',
        params,
    });
}
// 上传图片 oss
export function imageFileUpload(data, params) {
    return request({
        url: '/img/common/upload',
        method: 'post',
        data,
        params,
        timeout: 30 * 1000,
        baseURL: baseUrlFile().baseURLFile,
    });
}
// 上传到图片列表
export function add(data) {
    return request({
        url: comUrl + 'cms/pictureLib/add',
        method: 'post',
        data,
    });
}
// 校验重名
export function getName(params) {
    return request({
        url: comUrl + 'cms/pictureLib/getName',
        method: 'get',
        params,
    });
}
// 图片库删除单条
export function deleteById(params, logObj) {
    return request({
        url: comUrl + 'cms/pictureLib/deleteById',
        method: 'post',
        params,
        logObj,
        logFlag: {
            appName: '图片库',
            operModule: '删除图片',
        },
    });
}
// 图片库修改
export function doUpdate(data, params) {
    return request({
        url: comUrl + 'cms/pictureLib/update',
        method: 'post',
        data,
        params,
        timeout: 15 * 1000,
    });
}
// 图片下载
export function getImage(url) {
    return request({
        url: '/mwebapi/cms/getImage/' + url,
        method: 'get',
        baseURL: baseUrlFile().recordURL,
        responseType: 'blob',
    });
}
//图片详情
export function getImgDetail(params) {
    return request({
        url: comUrl + 'cms/pictureLib/getById',
        method: 'GET',
        params,
    });
}
//图片判断是否cmyk
export function cmyk(data, params) {
    return request({
        url: '/img/process/cmyk',
        method: 'post',
        data,
        params,
        dataType: 'form',
        baseURL: baseUrlFile().baseURLFile,
        timeout: 30 * 1000,
    });
}
// 图片cmyk转rgb
export function cmykToRgb(data, params) {
    return request({
        url: '/img/process/cmykToRgb',
        method: 'post',
        data,
        params,
        dataType: 'form',
        baseURL: baseUrlFile().baseURLFile,
        timeout: 30 * 1000,
    });
}
// 获取水印信息
export function getImageWatermark(params) {
    return request({
        url: '/mwebapi/cms/pictureLib/getWatermarkConfig',
        method: 'get',
        params,
        timeout: 10 * 1000,
    });
}
// 图片加速开关
export function updateWebpFlag(data) {
    let url = `/mwebapi/cms/pictureLib/updateWebpFlag?flag=${data.flag}`;
    if (data.id) {
        url = `/mwebapi/cms/pictureLib/updateWebpFlag?flag=${data.flag}&id=${data.id}`;
    }
    return request({
        url,
        method: 'post',
        // data,
        timeout: 30 * 1000,
    });
}

// 批量图片加速开关
export function updateBatchWebpFlag(data) {
    let url = `/mwebapi/cms/pictureLib/updateBatchWebpFlag?flag=${data.flag}`;
    // if (data.id) {
    //     url = `/mwebapi/cms/pictureLib/updateBatchWebpFlag?flag=${data.flag}&id=${data.id}`
    // }
    delete data.flag;
    return request({
        url,
        method: 'post',
        data: data.ids,
        // dataType: 'form',
        timeout: 30 * 1000,
    });
}

// 保存水印设置
export function updateWatermarkConfig(data) {
    return request({
        url: '/mwebapi/cms/pictureLib/updateWatermarkConfig',
        method: 'post',
        data,
        timeout: 10 * 1000,
    });
}
//打水印
export function watermarkb(data, params) {
    return request({
        url: '/img/process/watermarkb',
        method: 'post',
        data,
        params,
        baseURL: baseUrlFile().baseURLFile,
        timeout: 30 * 1000,
    });
}
//拷贝图片
export function imgCopy(data, params) {
    return request({
        url: '/img/common/copy',
        method: 'post',
        data,
        params,
        dataType: 'form',
        baseURL: baseUrlFile().baseURLFile,
        timeout: 10 * 1000,
    });
}
//水印预览
export function previewWatermark(data, params) {
    return request({
        url: 'img/process/previewWatermark',
        method: 'post',
        responseType: 'arraybuffer',
        data,
        params,
        dataType: 'form',
        baseURL: baseUrlFile().baseURLFile,
        timeout: 10 * 1000,
    });
}
//打水印
export function watermark(data, params) {
    return request({
        url: '/img/process/watermark',
        method: 'post',
        data,
        params,
        dataType: 'form',
        baseURL: baseUrlFile().baseURLFile,
        timeout: 30 * 1000,
    });
}
//删除缩略图
export function removeThumbnail(data, params) {
    return request({
        url: '/img/process/removeThumbnail',
        method: 'post',
        data,
        params,
        dataType: 'form',
        baseURL: baseUrlFile().baseURLFile,
    });
}
//裁剪
export function doCrop(data, params) {
    return request({
        url: '/img/process/crop',
        method: 'post',
        data,
        params,
        dataType: 'form',
        baseURL: baseUrlFile().baseURLFile,
        timeout: 10 * 1000,
    });
}
//	清理缓存
export function clearCDNCache(data, params) {
    return request({
        url: '/img/common/clearCdn',
        method: 'post',
        data,
        params,
        timeout: 1000 * 60 * 60,
        baseURL: baseUrlFile().baseURLFile,
    });
}
//	清理缓存
export function clearCDNCacheImg(data, params) {
    return request({
        url: '/img/common/clearCdn',
        method: 'post',
        data,
        params,
        timeout: 1000 * 60 * 60,
        baseURL: baseUrlFile().baseURLFile,
    });
}
//缩放
export function resize(data, params) {
    return request_video({
        url: '/img/process/resize',
        method: 'post',
        data,
        params,
        dataType: 'form',
        baseURL: baseUrlFile().baseURLFile,
        timeout: 30 * 1000,
    });
}
//图片符合处理预览
export function compoundProcessPreview(data, params) {
    return request_video({
        url: '/img/process/compoundProcessPreview',
        method: 'post',
        data,
        params,
        dataType: 'form',
        baseURL: baseUrlFile().baseURLFile,
        timeout: 30 * 1000,
        responseType: 'blob',
    });
}
export function compoundProcessPreview1(data, params) {
    return request_video({
        url: '/img/process/compoundProcessPreview',
        responseType: 'arraybuffer',
        method: 'post',
        data,
        params,
        dataType: 'form',
        baseURL: baseUrlFile().baseURLFile,
        timeout: 30 * 1000,
    });
}
export function qualitySet(data, params) {
    return request_video({
        url: '/img/process/quality',
        method: 'post',
        data,
        params,
        dataType: 'form',
        baseURL: baseUrlFile().baseURLFile,
        timeout: 30 * 1000,
    });
}
//添加文件
export function addCategory(data, params) {
    return request({
        url: comUrl + 'cms/libraryCategory/add',
        method: 'POST',
        data,
        params,
    });
}
//删除文件夹
export function deleteCategory(params) {
    return request({
        url: comUrl + 'cms/libraryCategory/delete',
        method: 'GET',
        params,
    });
}
//获取文件夹
export function findAllCategory(params) {
    return request({
        url: comUrl + 'cms/libraryCategory/findAll',
        method: 'get',
        params,
    });
}
//编辑文件夹
export function updateCategory(params) {
    return request({
        url: comUrl + 'cms/libraryCategory/update',
        method: 'GET',
        params,
    });
}
//转移数据
export function updateChangeCategory(data, params) {
    return request({
        url: comUrl + 'cms/libraryCategory/updateChangeCategory',
        method: 'POST',
        data,
        params,
    });
}
//转移文件夹
export function updateMoveCategory(data) {
    return request({
        url: comUrl + 'cms/libraryCategory/updateMoveCategory',
        method: 'POST',
        data,
        dataType: 'form',
    });
}
//智能图生图
export function createImage(data) {
    return request({
        url: comUrl + 'batch/intelligeImage/createImage',
        method: 'POST',
        data,
    });
}
//获取智能图生图状态接口
export function getStatus(params) {
    return request({
        url: comUrl + 'batch/intelligeImage/getStatus',
        method: 'GET',
        params,
    });
}
//查询使用次数
export function getUsedNumber(data) {
    return request({
        url: comUrl + 'batch/intelligeImage/getUsedNumber',
        method: 'POST',
        data,
    });
}
//记录图生图
export function addPictureId(params) {
    return request({
        url: comUrl + 'batch/intelligeImage/addPictureId',
        method: 'GET',
        params,
    });
}
//查询智能图生图记录接口
export function findPictureIds(data) {
    return request({
        url: comUrl + 'batch/intelligeImage/findPictureIds',
        method: 'POST',
        data
    });
}


//查询配置
export function findOneByTenantIdAndKeyWord(data,params) {
    return request({
        url: '/pms/tenantRecord/findOneByTenantIdAndKeyWord',
        method: 'POST',
        data,
        params
    });
}
//图片重命名
export function update(data, params) {
    return request({
        url: `${comUrl}cms/common/update`,
        method: 'POST',
        data,
        params
    });
}
//提交接口
export function commitSegmentTask(data, params) {
    return request({
        url: `api/analysis/commitSegmentTask`,
        method: 'POST',
        data,
        params
    });
}
//查询接口
export function getSegmentTaskByIds(params) {
    return request({
        url: `api/analysis/getSegmentTaskByIds`,
        method: 'GET',
        params
    });
}


// 多文件打包压缩接口
export function createCompressFile(data, logObj) {
    return request({
        url: '/img/common/createCompressFile',
        method: 'post',
        data,
        // dataType: 'form',
        baseURL: baseUrlFile().baseURLFile,
        timeout: 30 * 1000,
        logObj,
        logFlag: {
            appName: '图片库',
            operModule: '批量下载图片',
        },
    });
}
export function getFileInfo(params) {
    return request({
        url: '/file/common/getFileInfo',
        method: 'get',
        params,
        // dataType: 'form',
        baseURL: baseUrlFile().baseURLFile,
        timeout: 30 * 1000,
    });
}
// 生成添加记录
export function submitDownload (data, params) {
    return request({
        url: '/mwebapi/batch/commonJob/submit',
        method: 'post',
        data,
        params,
        timeout: 30 * 1000,
    });
}


export function getRecordList (params) {
    return request({
        url: '/mwebapi/batch/commonJob/list',
        method: 'get',
        params,
        timeout: 30 * 1000,
    });
}
export function updateState (params) {
    return request({
        url: '/mwebapi/batch/commonJob/updateState',
        method: 'post',
        params,
        timeout: 30 * 1000,
    });
}


// 直接删
export function deleteFile(data, params) {
    const formData = new FormData();
    Object.keys(data).forEach(key => formData.append(key, data[key]));
    return request({
        url: '/file/common/delete?deleteFile=1',
        method: 'post',
        data: formData,
        params,
        timeout: 30 * 1000,
        baseURL: baseUrlFile().baseURLFile,
    });
}

